/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.templates.create.schedules.create.resources.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.templates',
  'acme.common.service.resources',
  'acme.common.service.permissions',
  'acme.common.service.themesHelper',
  'acme.view.application.resources.modals.request.controllers'
])

.controller('TemplatesCreateSchedulesCreateResourcesController', ['$scope', '$state', '$uibModal', '$timeout', 'ApiService', 'HelpersService', 'CalendarService', 'TemplatesService', 'ResourcesService', 'PermissionsService', 'ThemesHelperService', function($scope, $state, $uibModal, $timeout, ApiService, HelpersService, CalendarService, TemplatesService, ResourcesService, PermissionsService, ThemesHelperService) {

    $scope.templatesCreateSchedulesCreateResources = {

      model: [],

      schedule: {},

      emailSetting: 'always',
      company: ThemesHelperService.getCompany(),

      createPermissions: ['RESOURCES_REQUESTS_PERSON_CREATE', 'RESOURCES_REQUESTS_PLACE_CREATE', 'RESOURCES_REQUESTS_EQUIPMENT_CREATE'],

      grid: {
        pageSize: 50,
        paginate: true,
        showFooter: true,
        multiselect: false,
        enableRowSelection: false,
        columns: [
          {
            field: 'action',
            displayName: 'Edit',
            onCellNavClick: function(row, col) {
              $scope.templatesCreateSchedulesCreateResources.update(row.entity.category, row.entity);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.update(row.entity.category, row.entity)" role="link">Edit<span class="sr-only">Edit Resource</span></a></div>',
            width: 60
          },
          {
            field: 'resourceCategory',
            displayName: 'Resource Category',
            visible: false
          },
          {
            field: 'category',
            displayName: 'Category',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'startTime',
            displayName: 'Start',
            width: 170
          },
          {
            field: 'endTime',
            displayName: 'End',
            width: 170
          },
          {
            field: 'resourceTemplate',
            displayName: 'Type'
          },
          {
            field: 'attributes',
            displayName: 'Attributes'
          },
          {
            field: 'quantity',
            displayName: 'Quantity'
          },
          {
            field: 'resource',
            displayName: 'Resource'
          },
          {
            field: 'notes',
            displayName: 'Notes'
          },
          {
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.templatesCreateSchedulesCreateResources.remove(row.entity);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.remove(row.entity)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          }
        ]
      },

      init: function() {
        this.template = TemplatesService.getModel();

        $scope.$on('TemplatesService::Update', this.onTemplatesServiceUpdate);
        $scope.$on('TemplatesCreateSchedulesCreateController::Save', this.onTemplatesCreateSchedulesCreateControllerSave);

        if ($state.params && $state.params.scheduleId) {
          this.schedule = TemplatesService.getScheduleById($state.params.scheduleId).schedule;
          if (this.schedule && TemplatesService.hasScheduleResourceRequests(this.schedule)) {
            ResourcesService.setSchedule(this.schedule);
            this.model = ResourcesService.processRequests(TemplatesService.getScheduleResourceRequests(this.schedule));
          }
        }else{
          this.schedule = TemplatesService.getNewSchedule().schedule;
        }

        this.getNotificationPreference();
      },

      isPrivateSchedule: function() {
        return (this.schedule.type === 'private');
      },

      getNotificationPreference: function() {
        if (this.company.hasOwnProperty('notificationPreference')) {
          this.emailSetting = this.company.notificationPreference;
        }
      },

      update: function(category, currentRequest) {
        if (PermissionsService.check('RESOURCES_REQUESTS_UPDATE')) {
          // May be in different scope
          $scope.templatesCreateSchedulesCreateResources.request(category, currentRequest, 'event');
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      assign: function(category, currentRequest) {
        if (PermissionsService.check($scope.templatesCreateSchedulesCreateResources.createPermissions)) {
          // May be in different scope
          $scope.templatesCreateSchedulesCreateResources.request(category, currentRequest, 'event');
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      setup: function(category, currentRequest) {
        if (PermissionsService.check($scope.templatesCreateSchedulesCreateResources.createPermissions)) {
          // May be in different scope
          $scope.templatesCreateSchedulesCreateResources.request(category, currentRequest, 'setup');
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      cleanup: function(category, currentRequest) {
        if (PermissionsService.check($scope.templatesCreateSchedulesCreateResources.createPermissions)) {
          // May be in different scope
          $scope.templatesCreateSchedulesCreateResources.request(category, currentRequest, 'cleanup');
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      request: function(category, currentRequest, preset) {
        var self = $scope.templatesCreateSchedulesCreateResources;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/resources/modals/request/request.tpl.html',
          size: 'lg',
          controller: 'ResourcesModalsRequestController',
          resolve: {
            resourceCategory: function() {
              return category || 'personnel';
            },
            schedule: function() {
              return self.schedule;
            },
            templateId: function() {
              return $state.params.id;
            },
            request: function() {
              return currentRequest || {};
            },
            preset: function() {
              return preset;
            },
            type: function() {
              return 'template';
            },
            emailSetting: function() {
              return self.emailSetting;
            },
            showEmailNotification: function() {
              return false;
            }
          }
        });

        self.showModal.result.then(function (request) {
          var found;

          if (request.id) {
            found = self.findRequest(request.id);

            if (found) {
              self.model[found.index] = ResourcesService.processRequest(request);
            }else {
              self.model.push(ResourcesService.processRequest(request));
            }
          }else {
            self.model.push(ResourcesService.processRequest(request));
          }
        }, function () {
        });
      },

      remove: function(item) {
        var self = $scope.templatesCreateSchedulesCreateResources;

        if (PermissionsService.check('RESOURCES_REQUESTS_DELETE')) {
          self.showRemoveModal = $uibModal.open({
            templateUrl: 'views/application/views/resources/requests/modals/remove.tpl.html',
            size: 'md',
            controller: 'ResourcesRequestsRemoveModalController',
            resolve: {
              resourceRequest: function () {
                var resourceCategory = (item.category === 'Person') ? 'Personnel' : item.category;
                return {
                  resourceTemplateName: item.eventResource ? item.eventResource.type : '',
                  eventName: self.template.name,
                  request: {
                    resourceCategory: resourceCategory,
                    resourceName: item.resource
                  }
                };
              },
              emailSetting: function () {
                return self.emailSetting;
              },
              showEmailNotification: function() {
                return false;
              }
            }
          });

          self.showRemoveModal.result.then(function (sendEmail) {
            var self = $scope.templatesCreateSchedulesCreateResources,
              found = self.findRequest(item.id),
              props = item;

            if (found) {
              self.model.splice(found.index, 1);
            }
            props.templateId = self.template.id;
            props.scheduleId = self.schedule.id;
            props.sendEmail = sendEmail;
            ApiService.program.resources.schedule.remove(props).then(self.success.remove, self.error.remove);
          },
          function () {
            //do nothing;
          });
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      findRequest: function(id) {

        var i, ii,
            r = false;

        if (id) {
          for (i = 0, ii = this.model.length; i < ii; i++) {
            if (this.model[i].id === id) {
              r = {
                index: i,
                request: this.model[i]
              };
              break;
            }
          }
        }

        return r;

      },

      getOriginalResourceRequests: function() {
        var requests = [],
            i, ii;
        for(i = 0, ii = this.model.length; i < ii; i++) {
          requests.push( {
            id: this.model[i].id,
            notes: this.model[i].notes,
            resourceTimeFrame : this.model[i].resourceTimeFrame,
            eventResource : this.model[i].eventResource
          });
        }
        return requests;
      },

      gridDoubleClick: function(row) {
        $scope.templatesCreateSchedulesCreateResources.update(row.entity.category, row.entity);
      },

      success: {
        remove: function(response) {}
      },

      error: {
        remove: function(response) {}
      },

      onTemplatesCreateSchedulesCreateControllerSave: function(e, data) {
        var self = $scope.templatesCreateSchedulesCreateResources,
            originalResourceRequests = self.getOriginalResourceRequests(self.model),
            model = angular.toJson(originalResourceRequests),
            templateResourceRequests = angular.toJson(TemplatesService.getScheduleResourceRequests(self.schedule));

        if (model !== templateResourceRequests) {
          console.log('TemplatesCreateSchedulesCreatePricingController::onTemplatesCreateSchedulesCreateControllerSave');
          TemplatesService.setScheduleResourceRequests(self.schedule, originalResourceRequests);
        }
      },

      onTemplatesServiceUpdate: function(e, data) {
        var self = $scope.templatesCreateSchedulesCreateResources;

        self.template = TemplatesService.getModel();

        // Next Tick
        $timeout(function() {
          if (self.schedule && TemplatesService.hasScheduleResourceRequests(self.schedule)) {
            self.model = ResourcesService.processRequests(TemplatesService.getScheduleResourceRequests(self.schedule));
          }
        }, 0);
      }

    };

    $scope.templatesCreateSchedulesCreateResources.init();

    $scope.appScopeProvider = {
      update: $scope.templatesCreateSchedulesCreateResources.update,
      remove: $scope.templatesCreateSchedulesCreateResources.remove,
      onGridDblClick: $scope.templatesCreateSchedulesCreateResources.gridDoubleClick
    };

}]);